import gql from "graphql-tag";

// fragment
export const PLANNED_TASK_FRAGMENT = gql`
    fragment plannedTask on PlannedTaskNode {
        id
        note
        numPhases
        plant {
            id
            name
            plantSpecies {
                id
                name
            }
        }
        color {
            id
            color
        }
        potSize {
            id
            potSizeCm
        }
        environment {
            id
            environment
        }
        tag {
            id
            tag
        }
        plantGrowthTemplate {
            id
            name
        }
        supplier {
            id
            name
        }
        totalGrowthDays
        maxSalesDays
        growthStartDate
        growthEndDate
        salesStartDate
        salesEndDate
        supplierOrderNo
        quantity
        unitPurchasePrice
        plantFixedCostRate
        plantFixedCostValue
        failureRate
        expectedSalesPrice
        productFixedCostRate
        productFixedCostValue
        currency
        plannedTaskPhaseSet {
            edges {
                node {
                    id
                    phaseNo
                    startDate
                    endDate
                    numDays
                    numPlantsPerM2
                    spaceM2
                    isSalesPhase
                }
            }
        }
        updatedAt
        updatedBy
    }
`;

export const SINGLE_PLANNED_TASK_FRAGMENT = gql`
    fragment singlePlannedTask on PlannedTaskNode {
        id
        note
        numPhases
        plant {
            id
            name
            plantSpecies {
                id
                name
            }
            plantTagSet {
                edges {
                    node {
                        id
                        tag {
                            id
                            tag
                            orderId
                        }
                    }
                }
            }
        }
        color {
            id
            color
        }
        potSize {
            id
            potSizeCm
        }
        environment {
            id
            environment
        }
        tag {
            id
            tag
        }
        plantGrowthTemplate {
            id
            name
        }
        supplier {
            id
            name
        }
        totalGrowthDays
        maxSalesDays
        growthStartDate
        growthEndDate
        salesStartDate
        salesEndDate
        supplierOrderNo
        quantity
        unitPurchasePrice
        plantFixedCostRate
        plantFixedCostValue
        failureRate
        expectedSalesPrice
        currency
        plannedTaskPhaseSet {
            edges {
                node {
                    id
                    phaseNo
                    startDate
                    endDate
                    numDays
                    numPlantsPerM2
                    spaceM2
                    isSalesPhase
                }
            }
        }
        createdAt
        updatedAt
        updatedBy
    }
`;

// all query
export const PLANNED_TASKS_QUERY = gql`
    query {
        tenantPlannedTasks {
            edges {
                cursor
                node {
                    ...plannedTask
                }
            }
        }
    }
    ${PLANNED_TASK_FRAGMENT}
`;

// single query
export const SINGLE_PLANNED_TASK_QUERY = gql`
    query plannedTask($id: ID!) {
        plannedTask(id: $id) {
            ...singlePlannedTask
        }
    }
    ${SINGLE_PLANNED_TASK_FRAGMENT}
`;

// create task
export const CREATE_PLANNED_TASK_MUTATION = gql`
    mutation createPlannedTask($input: CreatePlannedTaskInput!) {
        createPlannedTask(input: $input) {
            plannedTask {
                ...plannedTask
            }
        }
    }
    ${PLANNED_TASK_FRAGMENT}
`;

// update task
export const UPDATE_PLANNED_TASK_MUTATION = gql`
    mutation updatePlannedTask($input: UpdatePlannedTaskInput!) {
        updatePlannedTask(input: $input) {
            plannedTask {
                ...plannedTask
            }
        }
    }
    ${PLANNED_TASK_FRAGMENT}
`;

// update task status
export const UPDATE_PLANNED_TASK_STATUS_MUTATION = gql`
    mutation updatePlannedTaskStatus($input: UpdatePlannedTaskStatusInput!) {
        updatePlannedTaskStatus(input: $input) {
            plannedTask {
                ...plannedTask
            }
        }
    }
    ${PLANNED_TASK_FRAGMENT}
`;

// delete
export const DELETE_PLANNED_TASK_MUTATION = gql`
    mutation deletePlannedTask($input: DeletePlannedTaskInput!) {
        deletePlannedTask(input: $input) {
            plannedTask {
                ...plannedTask
            }
        }
    }
    ${PLANNED_TASK_FRAGMENT}
`;
